import * as React from 'react'

import { cn } from '@/lib/utils'
import { CONTROL_CLASS, useFieldProps } from './form-field'

/** The multi-line field (spec-64-u2, U-150): `Input`'s edge and fill, growing with `rows`. */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  const fieldProps = useFieldProps(props)
  return (
    <textarea
      data-slot="textarea"
      className={cn(CONTROL_CLASS, 'h-auto min-h-20 py-2 max-md:h-auto', className)}
      {...fieldProps}
    />
  )
}

export { Textarea }
